// extracted by mini-css-extract-plugin
export default {"testText":"testText___d1e61c8ed146b36b","fullWidth":"fullWidth___f32fb11aa44ba7ae","checked":"checked___a350c6256f78a904","results":"results___bb5b14fd76193b5d"};